let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bb8Dk")).then(() => parcelRequire('bpPEC'));